import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {OrderForm} from '../models/order-form';
import {Order} from '../models/order';

export const orderPatchActionTypes = {
  PATCH: type('[orders] Patch'),
  PATCH_SUCCESS: type('[orders] Patch Success'), // don't change this type because listening in order-add.component
  PATCH_FAIL: type('[orders] Patch Fail'),
};

export class PatchOrdersAction implements Action {
  readonly type = orderPatchActionTypes.PATCH;
  constructor(public payload?: {order: OrderForm, api: string}) {}
}

export class PatchOrdersSuccessAction implements Action {
  readonly type = orderPatchActionTypes.PATCH_SUCCESS;
  constructor(public payload?: Order) {}
}

export class PatchOrdersFailAction implements Action {
  readonly type = orderPatchActionTypes.PATCH_FAIL;
  constructor(public payload?: string) {}
}
